const ExportStatus = {
	PENDING: 'PENDING',
	RUNNING: 'RUNNING',
	COMPLETED: 'COMPLETED',
	FAILED: 'FAILED',
	DELETED: 'DELETED',
};

export default ExportStatus;
